import React, { useEffect, useState } from 'react';
import { hooks, Store, thunks } from '../../data';
// import Lottie, { useLottie } from 'lottie-react';
import Lottie from 'react-lottie';
import * as animationData from '../../lottie/flip.json';
import * as spl from '@solana/spl-token-v2';
import * as anchor from 'anchor-24-2';
import * as sbv2 from '@switchboard-xyz/switchboard-v2';
import coin from '../../../src/images/coin.png';
// import flip from '../../lottie/flip.json';
import { useSelector } from 'react-redux';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import logo from '../../../src/images/tag1.png';
import background from '../../../src/images/HOMEPAGE.png';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useConnectedWallet, useSolana } from '@saberhq/use-solana';
import { Severity } from '../../util/const';
import {GrClose} from "react-icons/gr";
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
//@ts-ignore
const Flip = ({ amount, setAmount }) => {
  const api = hooks.useApi();
  const [selected, setSelected] = useState(0);
  const [userAccountExists, setUserAccountExists] = useState(false);
  const balances = useSelector((store: Store) => store.gameState.userBalances);
  const result = useSelector((store: Store) => store.gameState.result);
  const user = useSelector((store: Store) => store.gameState.user);
  // const lottieOptions = {
  //   animationData: flip,
  //   autoplay: false,
  // };

  const defaultOptions = {
    loop: true,
    autoplay: false,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const loading = useSelector((store: Store) => store.gameState.loading);
  const logs = useSelector(({ HUDLogger }: Store) => HUDLogger.logs);
  const [open, setOpen] = React.useState(false);
  const [openModal, setModalOpen] = useState(false);
  const wallet = useConnectedWallet();
  const { walletProviderInfo, disconnect, providerMut, network, setNetwork } = useSolana();
  const dispatch = hooks.useThunkDispatch();

  const getReward = async () => {
    if (wallet && balances.ribs && providerMut) {
      try {
        let ixns = [];
        dispatch(thunks.setLoading(true));
        console.log(user.rewardAddress, 'user');
        ixns.push(
          spl.createCloseAccountInstruction(
            new anchor.web3.PublicKey(user.rewardAddress),
            wallet.publicKey,
            wallet.publicKey
          )
        );
        // ixns.push(createSyncNativeInstruction(wallet.publicKey, TOKEN_PROGRAM_ID));
        console.log(ixns, 'instructions');
        const tx = new anchor.web3.Transaction().add(...ixns);
        const packed = await sbv2.packTransactions(
          providerMut.connection,
          [tx],
          [] as anchor.web3.Keypair[],
          wallet.publicKey
        );

        const signedTxs = await wallet.signAllTransactions(packed);
        console.log('signedtxs');

        for (let k = 0; k < packed.length; k += 1) {
          const sig = await providerMut.connection
            .sendRawTransaction(
              signedTxs[k].serialize(),
              // req.signers,
              {
                skipPreflight: false,
                maxRetries: 10,
              }
            )
            .catch((e) => {
              dispatch(thunks.setLoading(false));
              dispatch(thunks.log({ message: 'Error converting wsol to sol. ', severity: Severity.Error }));
              console.log(e, 'error signing instruction');
            });
          console.log(sig, 'signed tx ', k);
          if (sig)
            await providerMut.connection.confirmTransaction(sig).catch((e) => {
              console.log(e, 'error confirming transaction');
              dispatch(thunks.setLoading(false));
              dispatch(thunks.log({ message: 'Error converting wsol to sol. ', severity: Severity.Error }));
              // dispatch(thunks.setResult({ status: 'claimed' }));
            });
          if (sig) console.log(sig, ' tx signature');
          if (sig) {
            dispatch(thunks.setLoading(false));
            handleModalClose();
            dispatch(thunks.log({ message: 'Successfully claimed funds. ', severity: Severity.Success }));
            dispatch(thunks.setResult({ status: 'claimed' }));
          }
        }
      } catch (e) {
        dispatch(thunks.setLoading(false));
        dispatch(thunks.log({ message: 'Error converting wsol to sol. ', severity: Severity.Error }));
        console.log(e, 'error');
      }
    }
  };
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    // console.log(logs, 'LOGS');
    if (logs && logs[0]?.severity === 'error') {
      // alert(logs[0].message);
      if (logs[0].message.includes("User hasn't created an account")) setUserAccountExists(false);
      else setUserAccountExists(true);
    }
    handleClick();
  }, [logs]);

  useEffect(() => {
    // console.log(user, 'user in redux')
    if (user && user.authority) {
      setUserAccountExists(true);
    }
  }, [user]);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  useEffect(()=>{
      if(result&& result.status=="success"){
        handleModalOpen()
      }
  },[result]);
  // const { View } = useLottie(lottieOptions);
  return (
    <div className="w-full  flex flex-wrap justify-center h-[800px]  py-10">
      <Snackbar open={open} onClose={handleClose}>
        <Alert onClose={handleClose} severity={logs[0]?.severity === 'error' ? 'error' : 'info'} sx={{ width: '100%' }}>
          {logs[0]?.message}
        </Alert>
      </Snackbar>
      <div className="lg:w-5/12 rounded-lg shadow bg-[#000]">
        <div className="text-4xl w-full  text-white py-8 font-bold ">
          <div className="flex justify-center">
            <img className="w-3/12" src={logo} />
          </div>
          <h1 className="meta text-center pt-4">FLIP</h1>
        </div>
        <div className="flex justify-center">
          {/* <div className="w-[200px]">{View}</div> */}
          <Lottie
            width={200}
            options={defaultOptions}
            isStopped={loading && result?.status == 'waiting' ? false : true}
          />
        </div>

        <div>
          <div>
            <div className="flex flex-wrap  px-12 py-6 justify-between">
              <button
                onClick={() => {
                  setSelected(1);
                }}
                className={`px-6 py-2 w-4/12 text-white font-semibold ${
                  selected == 1 ? 'bg-red-500' : 'bg-[#000]'
                } border-2 border-red-500   rounded-sm`}
              >
                HEADS
              </button>
              <button
                onClick={() => {
                  setSelected(2);
                }}
                className={`px-6 py-2 w-4/12 text-white font-semibold ${
                  selected == 2 ? 'bg-red-500' : 'bg-[#000]'
                } border-2 border-red-500   rounded-sm`}
              >
                TAILS
              </button>
            </div>
            <div className="flex justify-center px-12">
              {userAccountExists ? (
                <button
                  onClick={() => {
                    selected && api.handleCommand(`user play ${selected} ${amount}`);
                  }}
                  className="px-6 py-2 w-full flex items-center justify-center text-white font-semibold bg-[#ff080b] bg-opacity-70 hover:bg-opacity-100 hover:bg-[#ff080b] rounded-sm"
                >
                  PLAY
                  {loading ? (
                    <div className="center   ml-2 text-white border-white">
                      <CircularProgress size={14} color="inherit" />
                    </div>
                  ) : (
                    <></>
                  )}
                </button>
              ) : (
                <button
                  onClick={() => {
                    api.handleCommand(`user create`);
                  }}
                  className="text-center flex items-center justify-center px-6 py-2 w-full text-white font-semibold bg-[#ff080b] bg-opacity-70 hover:bg-opacity-100 hover:bg-[#ff080b] rounded-sm"
                >
                  CREATE ACCOUNT
                  {loading ? (
                    <div className="center   ml-2 text-white border-white">
                      <CircularProgress size={14} color="inherit" />
                    </div>
                  ) : (
                    <></>
                  )}
                </button>
              )}
            </div>
          </div>
          <div className="flex flex-wrap items-center py-6 text-white justify-center">
            <p className="font-semibold">BET AMOUNT:</p>
            <div className="flex justify-center bg-green-00 items-center  text-sm font-bold ">
              <input
                className=" bg-transparent w-[35%] focus:outline-none"
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
                placeholder="0.01"
              />
              <span> SOL</span>
            </div>
          </div>
          <div className="text-white flex flex-wrap justify-evenly px-12 py-4">
            <div>{balances.sol || 0} SOL</div>
            <div>{balances.ribs || 0} WSOl</div>
          </div>
        </div>

        <Modal
          open={openModal}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="w-screen  h-screen flex justify-center items-center ">
            <div className='w-6/12 relative bg-black border border-red-500 p-6 flex justify-center items-center'>
                 <div  onClick={()=>handleModalClose()} className='absolute right-0 top-0 p-2 bg-red-500 text-white'>
                      <GrClose/>
                 </div>
              {result && result.status == 'success' && result.userWon ? (
                <div className="text-white text-center  w-full">
                  <button onClick={() => getReward()}>Collect Reward</button>
                </div>
              ) : (
                <div className="text-white">Better luck next time.</div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Flip;
function dispatch(arg0: { payload: boolean; type: string }) {
  throw new Error('Function not implemented.');
}
